// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d1a095c","455":"994c0d41","857":"8998a91d"}[chunkId] + ".chunk.js";
};